import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SeguridadSocialService {
  private apiUrl =  `${environment.apiUrl}/api/seguridadsocial`; 
  //private apiUrl = 'http://localhost:3000/api/seguridadsocial';

  constructor(private http: HttpClient) {}

  getSeguridadSocial(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener los registros de seguridad social:', error);
        return throwError(() => new Error('No se pudo obtener la información de seguridad social.'));
      })
    );
  }

  // Agrega aquí métodos adicionales si los necesitas (crear, actualizar, eliminar).
}
